/* eslint-disable react-hooks/exhaustive-deps */
// import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { useEffect, useMemo, useState } from 'react';
import { DatePicker, Button, Form, Card, Space, Typography } from 'antd';
import MyPage from '../Page';
import moment from 'moment';
import TableSection from './component/table';
import FilterData from './component/filter';
import { FileSearchOutlined } from '@ant-design/icons'

const layoutStyles = {
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: 24,
        paddingBlock: 24
    },
    filterCard: {
        borderRadius: 24,
        backgroundColor: '#ffffff',
        boxShadow: '0 25px 45px rgba(15,23,42,0.08)',
        border: '1px solid #f2f4f7'
    },
    filterHeader: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        marginBottom: 16
    },
    dateControls: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 16
    },
    buttonGroup: {
        display: 'flex',
        alignItems: 'center'
    },
    filterSection: {
        borderRadius: 20,
        backgroundColor: '#fafbff',
        border: '1px dashed #d0d5dd',
        padding: 20
    },
    tableCard: {
        borderRadius: 28,
        backgroundColor: '#ffffff',
        padding: 8,
        boxShadow: '0 30px 55px rgba(15,23,42,0.08)' 
    }
};

export default ({ url, title, repType, FetchComponent, printHeaderReport, printFooterReport, onDataChange,
    onFilterChange, onDateChange }) => {
    const [timestamp, setTimestamp] = useState(moment().unix());
    const [startDate, setStartDate] = useState(moment());
    const [endDate, setEndDate] = useState(moment().add(1, 'day'));
    const [selectedValues, setSelectedValues] = useState([]);
    const [filterLists, setFilterLists] = useState([]);
    const curUrl = useMemo(() => {
        return `${startDate.format('DD-MMM-YYYY')}/${endDate.format('DD-MMM-YYYY')}`;
    }, [startDate, endDate]);
    const [uri, setUri] = useState(curUrl);

    const maxEndDate = useMemo(() => {
        const nextWeek = moment(startDate).add(7, 'day');
        return (nextWeek.unix() > moment().add(1, 'day').unix()) ? moment().add(1, 'day') : nextWeek;
    }, [startDate]);

    useEffect(() => {
        if (endDate.startOf('date').unix() > maxEndDate.startOf('date').unix()) {
            setEndDate(maxEndDate);
        }
    }, [maxEndDate])

    useEffect(() => {
        onFilterChange && typeof onFilterChange === 'function' && onFilterChange(selectedValues);
    }, [selectedValues])

    useEffect(() => {
        onDateChange && typeof onDateChange === 'function' && onDateChange(startDate, endDate);
    }, [startDate, endDate])

    const DailyBtn = () => (
        <Form layout='inline' style={{ width: '100%' }}>
            <Space size={16} wrap style={{ width: '100%' }}>
                <Form.Item label="Start Date" style={{ marginBottom: 0 }}>
                    <DatePicker
                        value={startDate}
                        format='DD-MMM-YYYY'
                        onChange={date => {
                            setStartDate(date);
                        }}
                        size='large'
                        allowClear={false}
                    />
                </Form.Item>
                <Form.Item label="End Date" style={{ marginBottom: 0 }}>
                    <DatePicker
                        value={endDate}
                        format='DD-MMM-YYYY'
                        onChange={date => {
                            setEndDate(date);
                        }}
                        allowClear={false}
                        size='large'
                    />
                </Form.Item>
                <Form.Item style={{ marginBottom: 0 }}>
                    <Button
                        type='primary'
                        size='large'
                        icon={<FileSearchOutlined />}
                        onClick={() => {
                            setUri(curUrl);
                            setTimestamp(moment().unix());
                        }}
                    >
                        Search
                    </Button>
                </Form.Item>
            </Space>
        </Form>
    );
    return (
        <MyPage title={title}>
            <div style={layoutStyles.wrapper}>
                <Card style={layoutStyles.filterCard} bodyStyle={{ padding: 24 }}>
                    <div style={layoutStyles.filterHeader}>
                        <Typography.Title level={5} style={{ margin: 0 }}>Rentang Tanggal</Typography.Title>
                        <Typography.Text type="secondary">
                            Pilih periode laporan maksimal 7 hari untuk menampilkan data terbaru.
                        </Typography.Text>
                    </div>
                    <DailyBtn />
                </Card>
                <div style={layoutStyles.filterSection}>
                    <FilterData
                        lists={filterLists}
                        idReport={`${url}${repType}`}
                        onFilterValueChange={fval => {
                            setSelectedValues(fval);
                        }}
                    />
                </div>
                <div style={layoutStyles.tableCard}>
                    <TableSection
                        date={uri}
                        baseUrl={url}
                        FetchComponent={FetchComponent}
                        repType={repType}
                        timestamp={timestamp}
                        selectedValue={selectedValues}
                        setFilterLists={setFilterLists}
                        printHeader={printHeaderReport}
                        printFooter={printFooterReport}
                        onDataChange={onDataChange}
                        title={title}
                    />
                </div>
            </div>
        </MyPage>
    )
}
